var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 61,
    viewBox: "0 0 80 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1433",
    "data-name": "Grupo 1433",
    transform: "translate(-1499 -13580)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_135",
    "data-name": "Elipse 135",
    cx: 35,
    cy: 35.5,
    rx: 35,
    ry: 35.5,
    transform: "translate(1504 13585)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_136",
    "data-name": "Elipse 136",
    transform: "translate(1499 13580)",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 40,
    ry: 40.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 39.5,
    ry: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1590",
    "data-name": "Trazado 1590",
    d: "M16.041,2.852a49.184,49.184,0,0,1,6.416.178,8.267,8.267,0,0,1,3.03.535,6.259,6.259,0,0,1,3.03,3.03,8.267,8.267,0,0,1,.535,3.03c0,1.6.178,2.139.178,6.416a49.183,49.183,0,0,1-.178,6.416,8.267,8.267,0,0,1-.535,3.03,6.259,6.259,0,0,1-3.03,3.03,8.267,8.267,0,0,1-3.03.535c-1.6,0-2.139.178-6.416.178a49.183,49.183,0,0,1-6.416-.178,8.267,8.267,0,0,1-3.03-.535,6.259,6.259,0,0,1-3.03-3.03,8.267,8.267,0,0,1-.535-3.03c0-1.6-.178-2.139-.178-6.416A49.184,49.184,0,0,1,3.03,9.624a8.267,8.267,0,0,1,.535-3.03A6.4,6.4,0,0,1,4.812,4.812,3.013,3.013,0,0,1,6.594,3.565a8.267,8.267,0,0,1,3.03-.535,49.184,49.184,0,0,1,6.416-.178m0-2.852A52.662,52.662,0,0,0,9.446.178,11,11,0,0,0,5.525.891,6.977,6.977,0,0,0,2.673,2.673,6.977,6.977,0,0,0,.891,5.525,8.121,8.121,0,0,0,.178,9.446,52.662,52.662,0,0,0,0,16.041a52.662,52.662,0,0,0,.178,6.594,11,11,0,0,0,.713,3.921,6.977,6.977,0,0,0,1.782,2.852A6.977,6.977,0,0,0,5.525,31.19a11,11,0,0,0,3.921.713,52.661,52.661,0,0,0,6.594.178,52.661,52.661,0,0,0,6.594-.178,11,11,0,0,0,3.921-.713,7.478,7.478,0,0,0,4.634-4.634,11,11,0,0,0,.713-3.921c0-1.782.178-2.317.178-6.594A52.661,52.661,0,0,0,31.9,9.446a11,11,0,0,0-.713-3.921,6.977,6.977,0,0,0-1.782-2.852A6.977,6.977,0,0,0,26.556.891,11,11,0,0,0,22.635.178,52.662,52.662,0,0,0,16.041,0m0,7.842a8.067,8.067,0,0,0-8.2,8.2,8.2,8.2,0,1,0,8.2-8.2m0,13.545a5.251,5.251,0,0,1-5.347-5.347,5.251,5.251,0,0,1,5.347-5.347,5.251,5.251,0,0,1,5.347,5.347,5.251,5.251,0,0,1-5.347,5.347M24.6,5.525a1.961,1.961,0,1,0,1.961,1.961A1.978,1.978,0,0,0,24.6,5.525",
    transform: "translate(1523 13604)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.34150eecaa48e40d520a7f443aadb2c9.svg";
export { ForwardRef as ReactComponent };